<template>
    <div class="market-color-container">
        <Title :title="title" />
        <div class="market-color__content">
            <table>
                <tbody>
                    <tr v-for="row in rows" :key="row">
                        <td v-for="col in itemsPerRow" :key="col">
                            <div class="market-select-item"
                                :class="{ 'active': colorSelected && colorSelected.id == getItem(row, col - 1).id }"
                                @click="selectColor(row, col - 1)">
                                <div class="name">
                                    <Number v-if="getItem(row, col - 1).slug" :bgColor="getItem(row, col - 1).slug" />
                                    <p>{{ getItem(row, col - 1).slug || '' }}</p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="market-color__action">
            <ButtonCommon text="add" class="button__primary" :isDisable="!colorSelected" @action="addColor" />
        </div>
    </div>
</template>
<script>
import Title from "@/components/common/title/index.vue";
import Number from "@/components/common/number";
import ButtonCommon from "@/components/common/button";
import EventBus from '@/utils/EventBus';

export default {
    components: { Title, Number, ButtonCommon },
    props: {
        outcomes: {
            type: Array,
        },
        title: {
            type: String,
        }
    },
    data() {
        return {
            colorSelected: null,
            rows: [],
            itemsPerRow: 3
        }
    },

    watch: {
        '$store.state.isScreenMobile': {
            handler(isMobile) {
                this.itemsPerRow = isMobile ? 3 : 4
                this.calculateRows()
            },
            deep: true,
        },
    },
    created() {
        this.calculateRows()
    },
    methods: {
        calculateRows() {
            const totalItems = this.outcomes.length;
            const totalCells = Math.ceil(totalItems / this.itemsPerRow) * this.itemsPerRow;
            const numberOfRows = totalCells / this.itemsPerRow;

            this.rows = Array.from({ length: numberOfRows }, (_, i) => i + 1);
        },
        getItem(row, col) {
            const index = (row - 1) * this.itemsPerRow + col;
            return this.outcomes[index] || '';
        },

        selectColor(row, col) {
            const item = this.getItem(row, col);
            if (item) this.colorSelected = item;
        },

        addColor() {
            this.$emit('addColor', this.colorSelected)
            this.colorSelected = null;

            setTimeout(() => {
                EventBus.emit('calculate-bottom-page')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/public/scss/components/coupons/market-color.scss";
</style>